import React, { useState } from 'react';
import { Eye, X } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Demo Mode Banner
 * Displays a visible indicator when user is in demo mode
 */
const DemoModeBanner = () => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  // Only show for demo users
  if (!user?.is_demo || dismissed) {
    return null;
  }

  return (
    <div className="bg-amber-500 text-white py-2 px-4">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-sm font-medium relative">
        <Eye className="w-4 h-4" />
        <span>
          <strong>Demo Mode</strong> - You are viewing as {user.role === 'admin' ? 'Admin' : 'Staff'}. 
          All changes are disabled.
        </span>
        <span className="text-amber-100">({user.demo_name || user.full_name})</span>
        <button
          onClick={() => setDismissed(true)}
          className="absolute right-0 p-1 hover:bg-amber-600 rounded transition-colors"
          title="Dismiss banner"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default DemoModeBanner;
